/**
 * Утилиты для управления data-атрибутом company на HTML элементе
 */

/**
 * Устанавливает data-company атрибут на HTML элементе
 * @param company - ключ компании (например, "soglasie", "ingosstrah", "reso")
 */
type CompanyMode = 'default' | 'ingos' | 'reso';
const companyMode = (process.env.REACT_APP_COMPANY_MODE ?? 'default') as CompanyMode;

const INGOS_COMPANY_KEY = 'ingosstrakh';
const RESO_COMPANY_KEY = 'reso';

export const setCompanyDataAttribute = (company: string | null): void => {
  const htmlElement = document.documentElement;

  // REACT_APP_COMPANY_MODE=ingos всегда в приоритете
  if (companyMode === 'ingos') {
    htmlElement.setAttribute('data-company', INGOS_COMPANY_KEY);
    return;
  }

  // REACT_APP_COMPANY_MODE=reso всегда в приоритете
  if (companyMode === 'reso') {
    htmlElement.setAttribute('data-company', RESO_COMPANY_KEY);
    return;
  }

  if (company) {
    htmlElement.setAttribute('data-company', company);
  } else {
    htmlElement.removeAttribute('data-company');
  }
};

/**
 * Получает текущее значение data-company атрибута
 * @returns значение атрибута или null
 */
export const getCompanyDataAttribute = (): string | null => {
  return document.documentElement.getAttribute('data-company');
};

/**
 * Очищает data-company атрибут
 */
export const clearCompanyDataAttribute = (): void => {
  setCompanyDataAttribute(null);
};

/** Ключи JSON с вариантами по бренду (футер, контакты, документы и т.п.) */
export type WhiteLabelJsonThemeKey = 'default' | 'ingosstrakh' | 'reso';

/**
 * Тема для текстов white-label: контакты, дисклеймер футера, ссылки на документы.
 * У Ресо в DOM часто `data-company=reso`, а `getCurrentThemeFromDom()` отдаёт `ingosstrakh` (легаси).
 */
export function getWhiteLabelJsonThemeKey(
  normalizedUiTheme: string | null | undefined,
): WhiteLabelJsonThemeKey {
  if (companyMode === 'reso') return 'reso';
  if (typeof document !== 'undefined' && getCompanyDataAttribute() === RESO_COMPANY_KEY) {
    return 'reso';
  }
  if (normalizedUiTheme === INGOS_COMPANY_KEY) return 'ingosstrakh';
  return 'default';
}

/**
 * Тексты «платформа» (Ингос) vs «BionMax» (дефолт/Согласие/Ресо).
 * Для ключей JSON с вариантами default | ingosstrakh.
 */
export function getBrandCopyThemeKey(
  normalizedUiTheme: string | null | undefined,
): 'ingosstrakh' | 'default' {
  return getWhiteLabelJsonThemeKey(normalizedUiTheme) === 'ingosstrakh'
    ? 'ingosstrakh'
    : 'default';
}
